import React, { useEffect, useState } from 'react';
import ImageMarquee from '../components/ImageMarquee'; // Import ImageMarquee
import { fetchMenu, fetchText } from '../utils/api';
import DataIcon from '../components/DataIcon';

/**
 * The Home Page component, serving as the landing page for the website.
 * @param {object} props - The component props.
 * @param {function} props.navigateTo - Function to navigate to a different page.
 */
const HomePage = ({ navigateTo }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const title = process.env.REACT_APP_TITLE;
  
  const [menu, setMenu] = useState([]);
  const [text, setText] = useState('');

  useEffect(() => {
    document.title = title;

    const getMenu = async () => {
      try {
        const menuData = await fetchMenu();
        setMenu(menuData);
      } catch (error) {
      } finally {
      }
    };

    const getText = async () => {
      try {
        const textData = await fetchText('_home/info.txt');        
        setText(textData);
      } catch (error) {
        console.error("Error fetching text:", error);
      }
    };

    getMenu();
    getText();
  }, []);

  return (
    <section className="bg-card-background p-6 md:p-8 rounded-xl shadow-lg mb-8 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4 border-b-2 border-border-light pb-2">
        Welcome to {title}
      </h2>
      <div className="flex flex-col md:flex-row items-center md:items-start md:text-left mb-6">
        <img
          src={`${apiUrl}/data/image?url=_images/logo.gif`} // Path to your logo in the public folder
          alt={`${title}`}
          className="w-48 md:mr-6 mb-4 md:mb-0 flex-shrink-0" // Added md:mr-6 for spacing, flex-shrink-0 to prevent shrinking
          onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/96x96/FFFFFF/000000?text=Logo"; }}
        />
        <div> {/* Container for text content */}
          {text.split('\n').map((line, index) => (
            <p key={index} className="text-lg text-text-dark mb-2">{line}</p>
          ))}
        </div>
      </div>

      {/* Image Marquee Integration */}
      <div className="my-8">
        <ImageMarquee />
      </div>

      <div className="mt-10 flex flex-col md:flex-row gap-4 justify-center items-center">
        {menu && menu.map((item, index) => (
          <button
            key={index}
            onClick={() => navigateTo(`/${item}`)}
            className="bg-accent-main hover:bg-accent-hover text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 flex items-center justify-center text-xl"
          >
            <DataIcon type={item} />
            {item}
          </button>
        ))}
      </div>
    </section>
  )
};

export default HomePage;
